import MmenuLight from 'mmenu-light';
import 'mmenu-light/dist/mmenu-light.css';

// Sticky menu
const header = document.querySelector(".site-header");

if (header) {
    window.addEventListener("scroll", stickyHeader, { passive: true });

    function stickyHeader() {
        const navbarHeight = header.offsetHeight + 2;
        const currentScroll = window.scrollY;

        if (currentScroll > navbarHeight) {
            header.classList.add("IsSticky");
        } else {
            header.classList.remove("IsSticky");
        }
    }
}

// Menu mobile
document.addEventListener('DOMContentLoaded', () => {
    const mobileNavRoot = document.querySelector('#mobile-nav');
    if (!mobileNavRoot) return;

    const defaultPanel = mobileNavRoot.querySelector('ul, .menu');

    if (!defaultPanel) {
        console.warn('Mobile navigation: markup missing a panel element (<ul class="menu">). Menu not initialized.');
        return;
    }

    const menu = new MmenuLight(mobileNavRoot);
    const navigator = menu.navigation({
        slidingSubmenus: false,
    });
    const drawer = menu.offcanvas({
        position: 'right',
    });

    navigator.openPanel(defaultPanel);

    const openNavBtn = document.getElementById('triggerMenuMobile');
    if (openNavBtn) {
        openNavBtn.addEventListener('click', () => {
            drawer.open();
            openNavBtn.setAttribute('aria-expanded', 'true');
        });
    }

    const closeNavBtn = document.querySelector('#close-nav');
    if (closeNavBtn) {
        closeNavBtn.addEventListener('click', () => {
            drawer.close();
            if (openNavBtn) openNavBtn.setAttribute('aria-expanded', 'false');
        });
    }

    // Close on backdrop click also resets aria
    const backdrop = document.querySelector('.mm-ocd__backdrop');
    if (backdrop && openNavBtn) {
        backdrop.addEventListener('mousedown', () => {
            openNavBtn.setAttribute('aria-expanded', 'false');
        });
    }
});
